import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Modificando ficha de cliente", -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "row m-0" }
const _hoisted_4 = { class: "d-flex pt-2 pb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Guardar Cambios ")

import Modal from "@/components/Modal.vue";
import { Field } from "@/types/components";
import { Form } from "vee-validate";
import { generateDynamicSchema } from "@/store/schemas/client.schema";
import { computed, onMounted, ref, watch } from "vue";
import useFormModal from "@/composables/FormModalComposable";
import {
	TypificationModalModule,
	actionType,
} from "@/store/modules/TypificationModal";
import { CallDataModule } from "@/store/modules/CallData";
import { IndexType } from "@/types/store";
import { AppModule } from "@/store/modules/app";
import { TicketModule } from "@/store/modules/Ticket";
import { coreApi } from "@/conection";
import { AlertModule } from "@/store/modules/Alert";
type FormPayload = {
	[k: string]: any;
};

// props

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	modelValue: boolean;
}

const loading = ref(false);
const error = ref("");

const { getComponent, getProps, hiddenInput } = useFormModal();
// types


// emits


// computeds
const form = computed<{ [k: string]: Field }>(
	() =>
		AppModule.userConfig?.data.reduce((acc, field) => {
			if (field.type !== "button") acc[field.name] = field;
			return acc;
		}, {} as { [k: string]: Field }) ?? {}
);
const schema = computed(() =>
	generateDynamicSchema(Object.values(form.value as any))
);

const edit = computed(() => {
	return TypificationModalModule.type === actionType.edit;
});

const user = computed<IndexType<string | number>>(() => {
	if (TicketModule.currentTicket?.client[0])
		return {
			...(TicketModule.currentTicket.client[0]?.customer ?? {}),
			...TicketModule.currentTicket.client[0]?.dynamicData,
		};
	return {
		...(CallDataModule.user?.customer ?? {}),
		...CallDataModule.user?.dynamicData,
	};
});

// watchs
watch(
	() => user.value,
	curr => {
		Object.keys(form.value).forEach(input => {
			form.value[input].value = curr[input] ? (curr[input] as any) : undefined;
			form.value[input].disabled = edit.value
				? form.value[input].blockOnEdit
				: false;
		});
	}
);

// Methods
function onSubmit(e: FormPayload) {
	loading.value = true;
	if (TicketModule.currentTicket?.client[0]) {
		const {
			first_name,
			second_name,
			third_name,
			last_name,
			last_name2,
			...dynamicData
		} = e;
		coreApi
			.put<{ success: boolean; message: string }>(
				`/api/client/${TicketModule.currentTicket?.client[0]._id}`,
				{
					ticket: TicketModule.currentRoomID,
					client: {
						customer: {
							first_name,
							second_name,
							third_name,
							last_name,
							last_name2,
						},
						dynamicData,
					},
				}
			)
			.then(response => {
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: response.data.message,
					type: "success",
				});
				setTimeout(() => emits("update:modelValue", false), 500);
			})
			.finally(() => (loading.value = false));
	} else
		CallDataModule.updateDynamicUser(e).then(() => {
			loading.value = false;
			setTimeout(() => emits("update:modelValue", false), 500);
		});
}

// Events
onMounted(async () => {
	/* 	const userForm = AppModule.configs.find(c => c.name === "dynamic_user");
	if (userForm)
		form.value = userForm.data.reduce((acc, field) => {
			acc[field.name] = field;
			return acc;
		}, {} as { [k: string]: Field }); */
	Object.keys(form.value).forEach(input => {
		form.value[input].value = user.value[input]
			? (user.value[input] as any)
			: undefined;
		form.value[input].disabled = edit.value
			? form.value[input].blockOnEdit
			: false;
	});
});

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.modelValue,
    "show-close": false,
    "modal-classes": "modal-secondary modal-dada",
    "body-classes": "py-0",
    "validate-on-mount": true,
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary",
    size: "xl"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "70vh",
        "view-class": "w-100",
        "wrap-class": "w-100"
      }, {
        default: _withCtx(() => [
          (error.value)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                title: error.value,
                type: "error",
                "show-icon": "",
                onClose: _cache[0] || (_cache[0] = () => (error.value = ''))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Form), {
            class: "w-100",
            "validation-schema": _unref(schema),
            onSubmit: _cache[2] || (_cache[2] = (e) => onSubmit(e))
          }, {
            default: _withCtx(({ values, setFieldValue }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(form)), (input, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["col-12 col-md-6 col-lg-4", {
								'd-none':
									input.hidden &&
									_unref(hiddenInput)(
										input.name,
										input.type,
										input.hidden,
										values,
										setFieldValue
									),
							}]),
                      key: index
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent((_unref(getComponent)(input.type) as any)), _mergeProps({
                        hidden: 
									input.hidden &&
										_unref(hiddenInput)(
											input.name,
											input.type,
											input.hidden,
											values,
											setFieldValue
										)
								
                      }, _unref(getProps)(input as Field, values), {
                        name: input.name,
                        type: input.type,
                        label: input.label,
                        placeholder: input.placeholder,
                        size: "sm",
                        "small-label": ""
                      }), null, 16, ["hidden", "name", "type", "label", "placeholder"]))
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_button, {
                    type: "link",
                    onClick: _cache[1] || (_cache[1] = () => emits('update:modelValue', false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_base_button, {
                    loading: loading.value,
                    type: "primary",
                    "native-type": "submit",
                    class: "ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})